import React from "react";
import { render } from "react-dom";

import CampaignCard from "components/CampaignCard";
import CampaignListing from "components/CampaignListing";
import StartACampaign from "widgets/StartACampaign";
import dataScroll from "helpers/dataScroll";

import "./style.scss";

if (document.getElementById("js-browse-live") !== null) {
  render(
    <CampaignListing>
      {window.Chuffed.liveCampaigns.map((campaign, index) => (
        <CampaignCard key={index} campaign={campaign} />
      ))}
    </CampaignListing>,
    document.getElementById("js-browse-live"),
  );
}

if (document.getElementById("js-browse-completed") !== null) {
  render(
    <CampaignListing>
      {window.Chuffed.completedCampaigns.map((campaign, index) => (
        <CampaignCard key={index} campaign={campaign} />
      ))}
    </CampaignListing>,
    document.getElementById("js-browse-completed"),
  );
}

// Start a campaign widget
if (document.getElementById("js-start-a-campaign") !== null) {
  render(
    <StartACampaign captchaToken={window.Captcha.v3} />,
    document.getElementById("js-start-a-campaign"),
  );
}

dataScroll();
